package br.com.logicalside.proposes.pages

import androidx.compose.runtime.Composable
import br.com.logicalside.proposes.components.layouts.PageLayout
import br.com.logicalside.proposes.components.sections.AboutSection
import br.com.logicalside.proposes.components.sections.ContactSection
import br.com.logicalside.proposes.components.sections.DownloadSection
import br.com.logicalside.proposes.components.sections.HeroSection
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun HomePage() {
    PageLayout("") {
        HeroSection()

        AboutSection()

        DownloadSection()

        ContactSection()
    }
}
